import { genericElementToFormData, onDelegatedEvent, debounce, setLoading, formDataToObject, addParamsToUrl, initAllModules, viewTransition } from '../functions.js';

export default class CheckboxeableElement extends HTMLElement {
    
    connectedCallback() {

        let element         = this;
        var shiftPressed    = false;
        var lastChanged     = null;
        let itemSelector    = this.dataset.itemSelector;
        let generalSelector = this.dataset.generalSelector;

        onDelegatedEvent('change', this, generalSelector, (event) => {
            let items = this.querySelectorAll(itemSelector);

            if (event.target.checked) {
                items.forEach(item => item.checked = true);
                // $items.prop('checked', true).trigger('change');
            } else {
                items.forEach(item => item.checked = false);
                // $items.prop('checked', false).trigger('change');
            }

            return false;
        });
        

        this.addEventListener('keydown', (event) =>{
            if (event.shiftKey) {
                shiftPressed = true;
            }
        });

        this.addEventListener('keyup', (event) =>{
            if (event.key === 'Shift') {
                shiftPressed = false;
            }
        });

        onDelegatedEvent('change', this, itemSelector, event => {
            var iAmChecked = event.target.checked;
            let items = [...this.querySelectorAll(itemSelector)];

            if (iAmChecked && shiftPressed && lastChanged) {

                let lastIndex = items.indexOf(lastChanged);
                let thisIndex = items.indexOf(event.selectorTarget);

                items.forEach((item, i) => {
                    let min = Math.min(lastIndex, thisIndex);
                    let max = Math.max(lastIndex, thisIndex);
                    if (i >= min && i <= max) {
                        item.checked = true;
                    }
                });
            }

            lastChanged = event.target;

            // Verificamos que si hay algún item NO checkeado para deschekear el global.
            let anyNotChecked = items.some(item => !item.checked);

            let general = this.querySelector(generalSelector);
            
            if (anyNotChecked > 0) {
                general.checked = false;
            } else {
                general.checked = true;
            }
        });
    }
};

window.customElements.define('checkboxeable-element', CheckboxeableElement);

